import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito mucho dinero para empezar?',
    a: 'No, Shopify ofrece periodos de prueba y aquí usamos solo herramientas gratuitas.'
  }, {
    q: '¿Tengo que ser experto en computación?',
    a: 'No, si sabes usar Facebook y enviar correos, puedes seguir esta guía.'
  }, {
    q: '¿Qué pasa si no tengo producto?',
    a: 'El Capítulo 3 te enseña exactamente cómo elegir uno que se venda hoy.'
  }, {
    q: '¿Funciona fuera de Estados Unidos?',
    a: 'Sí, el método es universal, aunque está optimizado para la velocidad del mercado USA.'
  }, {
    q: '¿Tengo que mostrar mi cara en videos?',
    a: 'No, te enseñamos cómo hacer videos de productos efectivos sin salir frente a la cámara.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'El objetivo es que tu tienda esté recibiendo visitas en el segundo día.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-gray-50 px-4" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <div className="text-center mb-12" data-id="element-19">
          <h2 className="text-4xl md:text-5xl font-bold text-navy-900" data-id="element-20">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-22">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-23">
                <span className="text-xl font-bold text-navy-900 font-heading" data-id="element-24">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-brandOrange-500 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-25" />
              </button>

              <AnimatePresence data-id="element-26">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-27">
                    <div className="p-6 pt-0 text-gray-600 text-lg border-t border-gray-100 mt-2" data-id="element-28">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}